import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  clearCommunityDetails,
  getCommunityDetails,
} from "../../API/store/actions/community";
import { useSelector } from "react-redux";
import CoverBar from "./coverBar";
import AboutCommunity from "./aboutCommunity";
import { ScrollToTop } from "../../algorithms";

const CommunityDetails = (props) => {
  const params = useParams();
  const id = params.id;
  const [details, setDetails] = useState({});
  const userToken = useSelector((state) => state.login.userToken);
  const [procAdded, setProcAdded] = useState(false);
  useEffect(() => {
    resolver(getCommunityDetails, setDetails, id, userToken);
    ScrollToTop();
    return () => {
      clearCommunityDetails();
    };
  }, [id, procAdded]);

  useEffect(() => {
    let NavElements = document.querySelectorAll(".itemNav");
    for (let i = 0; i < NavElements?.length; i++) {
      if (
        NavElements[i]?.children[0]?.classList?.contains("iconsActiveClass")
      ) {
        NavElements[i]?.children[0]?.classList?.remove("iconsActiveClass");
        NavElements[i]?.classList?.remove("iconsBackgroundActiveClass");
      }
    }
  }, []);

  if (details)
    return (
      <>
        <CoverBar details={details?.data} />
        <AboutCommunity
          details={details?.data}
          procAdded={procAdded}
          setProcAdded={setProcAdded}
        />
      </>
    );
  return <div></div>;
};

export default CommunityDetails;
